(ns ycweb.app.website.website
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cookiebanner.cookiebanner :as cookiebanner]
   [ycweb.app.website.footer.footer :as footer]
   [ycweb.app.website.header.header :as header]))

(rum/defc screen-wrapper < rum/reactive [app-atom component options]
  [:<>
   (cookiebanner/cookiebanner app-atom)
   (header/header app-atom options)
   component
   (footer/footer app-atom options)])